import { CommonUtils, HtmlInsertPosition } from "../../../../util/common-utils";
import { Roles } from "../../../../constants/roles";
import { BoardMediaSliderSetup } from "../../../../post/list/board-media-slider-setup";
import { snsPreviewManagerForm } from "../../sns-preview-manager-form";

export class SnsCardPreviewMediaGridRender {
    public static renderBoardImagesGrid(mediaArea: HTMLElement, imageUrls: string[]): HTMLImageElement[] {
        if (!(mediaArea instanceof HTMLElement)) return [];

        const urls = (Array.isArray(imageUrls) ? imageUrls : [])
            .map((value) => String(value || "").trim())
            .filter(Boolean);
        if (urls.length === 0) return [];

        const existingVideo = snsPreviewManagerForm.getBoardVideoWrap(mediaArea);
        const preservedBadges = Array.from(mediaArea.children).filter(
            (child): child is HTMLElement => child instanceof HTMLElement && child.matches(".board-media-badges"),
        );

        const imagesHtml = urls
            .map((src) => {
                const safeSrc = CommonUtils.escapeHtmlAttribute(src);
                return `<img class="board-image" alt="Post image" loading="lazy" src="${safeSrc}">`;
            })
            .join("");

        const gridHtml = `<div class="board-images-rail board-images-grid" data-role="${CommonUtils.escapeHtmlAttribute(Roles.BOARD_IMAGES_GRID)}" data-count="${urls.length}">${imagesHtml}</div>`;
        CommonUtils.setHtml(mediaArea, gridHtml);

        preservedBadges
            .slice()
            .reverse()
            .forEach((badge) => {
                mediaArea.prepend(badge);
            });

        if (existingVideo instanceof HTMLElement) {
            mediaArea.appendChild(existingVideo);
        }

        BoardMediaSliderSetup.init(mediaArea);

        return snsPreviewManagerForm.getBoardImagesInMediaArea(mediaArea);
    }

    public static ensureIndexTilesGrid(mediaArea: HTMLElement): HTMLElement | null {
        if (!(mediaArea instanceof HTMLElement)) return null;

        const existing = snsPreviewManagerForm.getSnsPreviewTilesGrid(mediaArea);
        if (existing instanceof HTMLElement) return existing;

        mediaArea.insertAdjacentHTML(
            HtmlInsertPosition.AFTER_BEGIN,
            `<div class="sns-preview-tiles--index-grid" data-role="${CommonUtils.escapeHtmlAttribute(Roles.SNS_PREVIEW_TILES_GRID)}"></div>`,
        );
        const created = snsPreviewManagerForm.getSnsPreviewTilesGrid(mediaArea);
        return created instanceof HTMLElement ? created : null;
    }

    public static appendImageTileToIndexGrid(grid: HTMLElement, src: string): HTMLImageElement | null {
        if (!(grid instanceof HTMLElement)) return null;

        const safeSrc = CommonUtils.escapeHtmlAttribute(String(src || ""));
        grid.insertAdjacentHTML(
            HtmlInsertPosition.BEFORE_END,
            `<div class="sns-preview-tile sns-preview-tile--index" data-role="${CommonUtils.escapeHtmlAttribute(Roles.SNS_PREVIEW_TILE)}"><img class="sns-preview-thumb" data-role="${CommonUtils.escapeHtmlAttribute(Roles.SNS_PREVIEW_THUMB)}" alt="Media" src="${safeSrc}"></div>`,
        );

        const tile = grid.lastElementChild;
        const img = tile instanceof HTMLElement ? snsPreviewManagerForm.getSnsPreviewThumb(tile) : null;
        return img instanceof HTMLImageElement ? img : null;
    }

    public static appendVideoWrapTileToIndexGrid(grid: HTMLElement, videoWrap: HTMLElement): void {
        if (!(grid instanceof HTMLElement) || !(videoWrap instanceof HTMLElement)) return;

        grid.insertAdjacentHTML(
            HtmlInsertPosition.BEFORE_END,
            `<div class="sns-preview-tile sns-preview-tile--index" data-role="${CommonUtils.escapeHtmlAttribute(Roles.SNS_PREVIEW_TILE)}"></div>`,
        );
        const tile = grid.lastElementChild;
        if (tile instanceof HTMLElement) {
            tile.appendChild(videoWrap);
        }
    }

    public static appendOgpTileToIndexGrid(grid: HTMLElement): HTMLElement | null {
        if (!(grid instanceof HTMLElement)) return null;
        grid.insertAdjacentHTML(
            HtmlInsertPosition.BEFORE_END,
            `<div class="sns-preview-tile sns-preview-tile--index" data-role="${CommonUtils.escapeHtmlAttribute(Roles.SNS_PREVIEW_TILE)}"></div>`,
        );
        const tile = grid.lastElementChild;
        return tile instanceof HTMLElement ? tile : null;
    }
}
